<template>
    <form-container :header="translate('incomingChannel.incomingDocTargets')" v-on:save="save" :disabled="loading">
        <template v-slot:tabs>
            <tab :tabs="tabs" v-model="tab" ref="tabs"></tab>
        </template>
        <incoming-tab-content tabName="ortakalan" class="tab-panel" :currentTab="tab">
            <div class="row">
                <div class="col col-xs-10 col-sm-8 col-md-8 col-lg-6">
                    <div class="form-group row">
                        <label class="col-form-label col-sm-4">{{translate('externalSigner.name')}}</label>
                        <div class="col-sm-8">
                            <input @input="checkInput('name',$event)" v-model="data.name" ref="name" name="name" type="text" class="form-control" required />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-sm-4">{{translate('targetSystemImport.kind')}}</label>
                        <div class="col-sm-8">
                            <select v-model="data.type" ref="type" name="Type" v-on:blur="handleBlur" @change="typeChanged(data.type)" class="form-control">
                                <option value="Email">{{translate('login.email')}}</option>
                                <option v-if="hasModule('REM')" value="Kep">KEP</option>
                                <option v-if="hasModule('UETS')" value="Uets">UETS</option>
                                <option v-if="hasModule('SFTP')" value="Sftp">sFTP</option>
                                <option v-if="hasModule('FTP')" value="Ftp">FTP</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-4"></div>
                        <div class="col-sm-8">
                            <label>
                                <input type="checkbox" v-model="data.isActive" />
                                {{translate('incomingChannel.targetActive')}}
                            </label>
                        </div>
                    </div>
<!-- 
                    <component v-if="data.type == 'Email'" v-bind:is="data.type" v-on:blur="handleBlur"
                        v-model="data.iMapDetails" name="iMapDetails" @ftpLookupTargetSystem="ftpLookupTargetSystem">
                    </component>
                    <component v-if="data.type == 'Kep'" v-bind:is="data.type" v-on:blur="handleBlur"
                        v-model="data.remDetails" name="remDetails" @ftpLookupTargetSystem="ftpLookupTargetSystem">
                    </component>
                    <component v-if="data.type == 'Uets'" v-bind:is="data.type" v-on:blur="handleBlur"
                        v-model="data.remDetails" name="remDetails" @ftpLookupTargetSystem="ftpLookupTargetSystem">
                    </component>
                    <component v-if="data.type == 'Sftp'" v-bind:is="data.type" v-on:blur="handleBlur"
                        v-model="data.ftpDetails" name="ftpDetails" @ftpLookupTargetSystem="ftpLookupTargetSystem">
                    </component> -->
                    <!-- <component v-if="data.type == 'Ftp'" v-bind:is="data.type" v-on:blur="handleBlur"
                        v-model="data.ftpDetails" name="ftpDetails" @ftpLookupTargetSystem="ftpLookupTargetSystem">
                    </component> -->
                    <div v-if="data.type == 'Email'">
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">Host:</label>
                            <div class="col-sm-8">
                                <input @input="checkIMapDetails('Host',$event)" v-model="data.iMapDetails.Host" v-on:blur="handleBlur" type="text" name="Host" class="form-control" />
                            </div>
                        </div>    
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">Port:</label>
                            <div class="col-sm-8">
                                <input @input="checkIMapDetails('Port',$event)" v-model="data.iMapDetails.Port" v-on:blur="handleBlur" type="number" name="Port" class="form-control"  />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.address')}}:</label>
                            <div class="col-sm-8">
                                <input @input="checkIMapDetails('Address',$event)" v-model="data.iMapDetails.Address" v-on:blur="handleBlur" type="text" name="Address" class="form-control"  />
                            </div>
                        </div>    
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.username')}}:</label>
                            <div class="col-sm-8">
                                <input @input="checkIMapDetails('UserName',$event)" v-model="data.iMapDetails.UserName" v-on:blur="handleBlur" type="text" name="UserName" class="form-control"  />
                            </div>
                        </div>    
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.password')}}:</label>
                            <div class="col-sm-8">
                                <password v-model="data.iMapDetails.Password" v-on:blur="handleBlur" name="Password" id="iMapDetails.Password" class="form-control"  @change="$forceUpdate()" />
                            </div>
                        </div>
                        
                        <!-- <div class="form-group row">
                            <label class="col-form-label col-sm-4">Şifreleme Tipi:</label>
                            <div class="col-sm-8">
                                <select class="form-control" v-model="data.iMapDetails.EncodingType" name="EncodingType">
                                    <option value="option1">option 1</option>              
                                    <option value="option2">option 2</option>              
                                    <option value="option3">option 3</option>              
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">Alım Tipi:</label>
                            <div class="col-sm-8">
                                <select class="form-control"  v-model="data.iMapDetails.RecipientType" name="RecipientType">
                                    <option value="IMAP">IMAP</option>              
                                    <option value="POP">POP</option>              
                                </select>
                            </div>
                        </div> -->
                    </div>
                    <div v-if="data.type == 'Kep'">
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.remProvider')}}:</label>
                            <div class="col-sm-8">
                                <select class="form-control" v-model="data.remDetails.RemProviderType" v-on:blur="handleBlur" name="RemProviderType">
                                    <option value="TnbKep">TNB KEP</option>              
                                    <option value="TurkKep">Türk KEP</option>              
                                    <option value="PttKep">PTT KEP</option>              
                                </select>
                            </div>
                        </div>    
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.address')}}:</label>
                            <div class="col-sm-8">
                                <input @input="checkRemDetails('Address',$event)" v-model="data.remDetails.Address" v-on:blur="handleBlur" name="Address" type="text" class="form-control"  />
                            </div>
                        </div>    
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.userId')}}:</label>
                            <div class="col-sm-8">
                                <input @input="checkRemDetails('UserId',$event)" v-model="data.remDetails.UserId" v-on:blur="handleBlur" name="UserId" type="text" class="form-control"  />
                            </div>
                        </div>    
                        <div class="form-group row" v-if="data.remDetails.RemProviderType == 'PttKep'">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.userPasscode')}}:</label>
                            <div class="col-sm-8">
                                <input v-model="data.remDetails.PasswordKey" v-on:blur="handleBlur" name="PasswordKey" type="password" class="form-control"  maxlength="11" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.userPassword')}}:</label>
                            <div class="col-sm-8">
                                <password v-model="data.remDetails.Password" v-on:blur="handleBlur" name="Password" id="remDetails.Password" class="form-control"  @change="$forceUpdate()" />
                            </div>
                        </div>
                        <!-- <div class="form-group row">
                            <label class="col-form-label col-sm-4">Giriş Tipi:</label>
                            <div class="col-sm-8">
                                <select class="form-control" v-model="data.remDetails.LoginType" v-on:blur="handleBlur">
                                    <option value="option1">option1</option>              
                                    <option value="option2">option2</option>              
                                </select>
                            </div>
                        </div> -->
                    </div>
                    <div v-if="data.type == 'Uets'">
                        <div class="form-group row" v-if="!uetsLoading">
                            <label class="col-form-label col-sm-4">API Key:</label>
                            <div class="col-sm-8">
                                <password :disabled="!isOnPrem" v-model="data.uetsDetails.ApiKey" v-on:blur="handleBlur" name="ApiKey" id="uetsDetails.ApiKey" class="form-control"  @change="$forceUpdate()" />
                            </div>
                        </div>
                        <div class="form-group row" v-if="!uetsLoading">
                            <label class="col-form-label col-sm-4">{{translate('incomingChannel.requestRate')}}:</label>
                            <div class="col-sm-8">
                                <input :disabled="!isOnPrem" v-model="data.uetsDetails.RequestRate" name="RequestFrequency" v-on:blur="handleBlur" type="number" class="form-control"  />
                            </div>
                        </div>
                        <div class="form-group row" v-if="this.uetsLoading && !isOnPrem">
                            <div class="alert alert-info">
                                {{translate('processingMessages.uetsInfoLoading')}}
                            </div>
                        </div>
                        
                        <div class="form-group row" v-else-if="(data.uetsDetails.RequestRate == null) && !isOnPrem">
                            <div class="alert alert-danger">
                                {{translate('warnings.uetsWarning')}}
                            </div>
                        </div>
                        <div class="form-group row" v-else-if="(data.uetsDetails.RequestRate != null) && !isOnPrem">
                            <div class="alert alert-success">
                                {{translate('messages.uetsSuccess')}}
                            </div>
                        </div>
                        <div class="form-group row" v-else-if="!isOnPrem">
                            <div class="alert alert-info">
                                {{translate('errors.uetsInfoCantAccessed')}}
                            </div>
                        </div>
                    </div>
                    <div v-if="data.type == 'Sftp'">
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.host')}}/Port:</label>
                            <div class="col-4">
                                <input type="text" @input="checkSFTPDetails('Host',$event)" v-model="data.ftpDetails.Host" name="Host" v-on:blur="handleBlur" class="form-control"  maxlength="300" required/>
                            </div>
                            <div class="col-4">
                                <input type="number" v-model="data.ftpDetails.Port" name="Port" v-on:blur="handleBlur"  class="form-control"  min="1" max="65536" required />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.username')}}</label>
                            <div class="col">
                                <input @input="checkSFTPDetails('Username',$event)" v-model="data.ftpDetails.Username" name="UserName" v-on:blur="handleBlur" type="text" class="form-control"   @change="$forceUpdate()" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.passcode')}}</label>
                            <div class="col">
                                <password v-model="data.ftpDetails.Password" name="Password" v-on:blur="handleBlur" class="form-control"  @change="$forceUpdate()" />
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.fingerprint')}}</label>
                            <div class="col">
                                <input @input="checkSFTPDetails('FingerPrint',$event)" v-model="data.ftpDetails.FingerPrint" name="FingerPrint" v-on:blur="handleBlur" type="text" class="form-control"  />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.uzakDizin')}}</label>
                            <div class="col">
                                <div class="input-group mb-3">
                                    <input v-model="data.ftpDetails.Path" @input="checkSFTPDetails('Path',$event)" name="Path" type="text" v-on:blur="handleBlur" class="form-control"  />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-secondary" @click="$emit('ftpLookupTargetSystem')">
                                            {{translate('lookup')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="form-group row">
                            <div class="col col-sm-4"></div>
                            <div class="col">
                                <label>
                                    <input type="checkbox" v-model="data.ftpDetails.EnableSSL" />
                                    {{translate('incomingDoc.sslEnabled')}}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="data.type == 'Ftp'">
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.host')}}/Port:</label>
                            <div class="col-4">
                                <input type="text" @input="checkSFTPDetails('Host',$event)" v-model="data.ftpDetails.Host" v-on:blur="handleBlur" name="Host" class="form-control" maxlength="300" />
                            </div>
                            <div class="col-4">
                                <input type="number" v-model="data.ftpDetails.Port" v-on:blur="handleBlur" name="Port"  class="form-control" min="1" max="65536" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.username')}}</label>
                            <div class="col">
                                <input @input="checkSFTPDetails('Username',$event)" v-model="data.ftpDetails.Username" type="text" v-on:blur="handleBlur" name="UserName"  class="form-control"  @change="$forceUpdate()" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.passcode')}}</label>
                            <div class="col">
                                <password v-model="data.ftpDetails.Password" v-on:blur="handleBlur" name="Password" class="form-control"  @change="$forceUpdate()" />
                            </div>
                        </div>

                        <div class="form-group row">
                            <label class="col-form-label col-sm-4">{{translate('incomingDoc.uzakDizin')}}</label>
                            <div class="col">
                                <div class="input-group mb-3">
                                    <input v-model="data.ftpDetails.Path" @input="checkSFTPDetails('Path',$event)" v-on:blur="handleBlur" name="Path" type="text" class="form-control"  />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-secondary" @click="$emit('ftpLookupTargetSystem')">
                                            {{translate('lookup')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col col-sm-4"></div>
                            <div class="col">
                                <label>
                                    <input type="checkbox" v-model="data.ftpDetails.EnableSSL" />
                                    {{translate('incomingDoc.sslEnabled')}}
                                </label>
                            </div>
                        </div>
                    </div>
                    
                    <!-- <targetSystemLookup v-if="lookupResult" :lookupResult="lookupResult" @onclose="lookupResult = null"
                        @ftpLookupTargetSystem="ftpLookupTargetSystem" @ftpLookupPathSelected="ftpLookupPathSelected">
                    </targetSystemLookup> -->

                    <div class="form-group row">
                        <div class="col-sm-4">
                        </div>
                        <div class="col-sm-8">

                        </div>
                        <!-- <targetSystemTest v-if="testResult" :testResult="testResult" @onclose="testResult = null">
                        </targetSystemTest> -->
                    </div>
                </div>
            </div>
            <!-- </fieldset> -->
            <incoming-alerts v-model="tab" :validationData="this.validationData" :tabs="tabs" :refs="$refs" />
        </incoming-tab-content>
        <incoming-tab-content tabName="filtreleme" class="tab-panel" :currentTab="tab">
            <!-- <fieldset id="tab-filtreleme" class="tab-panel" v-show="tab == 'filtreleme'"> -->
            <div class="d-flex flex-row">
                <!-- kaydedilen filtre buraya gelecek
                this.incomingFilter basılacak -->
                <div class="d-flex flex-column">
                    <div class="d-flex flex-column" v-for="(item, counter) in data.incomingFilters"
                        v-bind:key="counter">
                        <div class="d-flex align-items-center justify-center">
                            <div class="p-2">
                                <button @click="editFilter(item,counter)" type="button" class="editButton">
                                    <svg class="bi bi-pencil-square" width="1em" height="1em" viewBox="0 0 16 16"
                                        fill="blue" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path fill-rule="evenodd"
                                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                                    </svg>
                                </button>
                            </div>
                            <div class="p-2">
                                <button @click="deleteFilter(counter)" type="button" class="deleteButton">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-trash text-danger"
                                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                        <path fill-rule="evenodd"
                                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                    </svg>
                                </button>
                            </div>
                            <div class="p-2" style="font-weight: bold">{{ " Filtre: "+item.filterName}}</div>

                            <!-- <div class="d-flex flex-row" v-for="(item2, counter2) in item" v-bind:key="counter2">
                            <div class="p-2">{{item.VariableName.name}}</div>
                            <div class="p-2">{{item.VariableMatchType.name}}</div>
                            <div class="p-2">{{item.VariableValue}}</div>
                            <div class="p-2">{{item.NextConditionConnectionType}}</div>
                        </div> -->
                        </div>
                    </div>
                </div>


            </div>
            <div class="form-group row">
                <div class="col-5"></div>
                <button type="button" class="btn btn-primary col-2" @click="addFilter">{{translate('incomingDoc.filterEditor.addFilter')}}</button>
                <div class="col-5"></div>

            </div>
            <incoming-filter-editor v-if="incomingFilterForEdit" @cancel="incomingFilterForEdit = false"
                @apply="apply" v-model="incomingFilter" />


            <div class="form-group row d-flex justify-content-center align-items-center" style="margin-top: 5%;">
                <div class="col-md-auto">
                    <label>
                        {{translate('incomingChannel.filterText')}}
                    </label>
                </div>
            </div>

            <div class="form-group row" name="defaultRecipients">
                <div class="form-group col">
                    <label>{{translate('incomingDoc.filterEditor.categories')}}</label>
                    <select-multiple :autocomplete="true" v-model="data.defaultCategoryIds" :list="categories">
                        <template slot-scope="{ item }">
                            <div>
                                <small class="float-right badge">{{item.Type | documentType }}</small>
                            {{item.Name}}
                            </div>
                        </template>
                    </select-multiple>
                </div>
                <div class="form-group col">
                    <label>{{translate('incomingDoc.filterEditor.targetDepartments')}}</label>
                    <select-multiple v-model="data.defaultRecipients.DepartmentIds" :autocomplete="true"
                        :list="departments"></select-multiple>
                </div>
                <div class="form-group col">
                    <label>{{translate('incomingDoc.filterEditor.targetUsers')}}</label>
                    <select-multiple v-model="data.defaultRecipients.UserIds" :autocomplete="true"
                        :list="userList" :getText="x => x.FullName" :emptyLabel="this.loadingLabel"
                        class="user-select-input">
                        <template slot-scope="{ item }">
                            <div v-if="item" class="d-flex align-items-center">
                                <div class="d-flex w-100 justify-content-between">
                                    <span>{{ item.FullName }}</span>
                                    <small class="text-right align-items-center">{{ item.Title.Name }}</small>
                                </div>
                            </div>
                            <div v-else>
                                <span>{{translate('loading')}}</span>
                            </div>
                        </template>
                    </select-multiple>
                </div>
            </div>



            <!-- </fieldset> -->
            <incoming-alerts v-model="tab" :validationData="this.validationData" :tabs="tabs" :refs="$refs" />
        </incoming-tab-content>
        <incoming-tab-content tabName="arsivler" class="tab-panel" :currentTab="tab">
            <!-- <fieldset id="tab-arsivler" class="tab-panel" v-show="tab == 'arsivler'"> -->
            <div class="row">
                <div class="col col-xs-10 col-sm-8 col-md-8 col-lg-6">
                    <div class="form-group row">
                        <label class="col-form-label col-sm-3">{{translate('incomingChannel.archiveType')}}</label>
                        <div class="col-sm-8">
                            <select v-model="data.archiveDetails.ArchiveType" name="archiveType" class="form-control" required>
                                <option v-if="isOnPrem" value="FileSystem">{{translate('incomingChannel.filePath')}}</option>
                                <option value="Delete">{{translate('incomingChannel.sil')}}</option>
                                <option v-if="hasModule('SFTP')" value="SFtp" hidden>sFTP</option>
                                <option v-if="hasModule('FTP')" value="Ftp" hidden>FTP</option>
                                <option value="uygulama" hidden>{{translate('incomingChannel.application')}}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="data.archiveDetails.ArchiveType != 'Delete'">
                        <component v-bind:is="data.archiveDetails.ArchiveType" v-model="data.archiveDetails" @ftpLookupTargetSystem="ftpLookupTargetSystem"> </component>
                    </div>                    
                    <targetSystemLookup v-if="lookupResult" :lookupResult="lookupResult" @onclose="lookupResult = null"
                        @ftpLookupTargetSystem="ftpLookupTargetSystem" @ftpLookupPathSelected="ftpLookupPathSelected">
                    </targetSystemLookup>
                    <div class="form-group row">
                        <label class="col-form-label col-sm-8">{{translate('incomingChannel.readDocKeepTime')}}:</label>
                        <div class="col-sm-4">
                            <input type="number" v-model="data.archiveDetails.ReadExpirationDay" max="10" name="readExpirationDay" class="form-control" required />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-form-label col-sm-8">{{translate('incomingChannel.unreadDocKeepTime')}}:</label>
                        <div class="col-sm-4">
                            <input type="number" v-model="data.archiveDetails.DefaultExpirationDay" max="30" name="defaultExpirationDay" class="form-control" required />
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-3">
                        </div>
                        <div class="col-sm-8">
                        </div>
                        <targetSystemTest v-if="testResult" :testResult="testResult" @onclose="testResult = null">
                        </targetSystemTest>
                    </div>
                </div>
                <div class="col">
                </div>
            </div>
            <!-- </fieldset> -->
            <incoming-alerts v-model="tab" :validationData="this.validationData" :tabs="tabs" :refs="$refs" />
        </incoming-tab-content>
        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <button type="button" v-on:click="goBack" class="btn btn-outline-primary"
                        style="margin-right: 10px;">{{translate('goBack')}}</button>
                    <tab-nav :tabs="tabs" :nextButton="false" v-model="tab"></tab-nav>
                </div>
                <div class="col text-right">
                    <tab-nav :tabs="tabs" :prevButton="false" v-model="tab" style="margin-right:12px;"></tab-nav>
                    <button type="button" @click="saveChannel()" v-show="tab == 'arsivler'" class="btn btn-success">{{translate('save')}}</button>
                </div>
            </div>

        </template>

    </form-container>
</template>

<script>
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import tab from '../components/Tab.vue'
import incomingTabContent from '../components/IncomingTabContent.vue';
import tabNav from '../components/TabNav.vue'
import Email from '../components/IncDocComps/IncDocEmail.vue'
import Docpath from '../components/IncDocComps/IncDocPath.vue'
import Sftp from '../components/IncDocComps/IncDocSFTP.vue'
import Ftp from '../components/IncDocComps/IncDocFTP.vue'
import targetSystemLookup from '../components/TargetSystemLookup.vue';
import axios from "axios";
import targetSystemTest from '../components/TargetSystemTest.vue';
import FileSystem from '../components/IncDocComps/IncDocPath.vue'
import Kep from '../components/IncDocComps/IncDocKEP.vue'
import Uets from '../components/IncDocComps/IncDocUets.vue'
import IncomingFilterEditor from '../components/IncDocComps/IncomingFilterEditor.vue'
import incomingAlerts from '../components/IncomingAlerts.vue'
import selectMultiple from '../components/SelectMultiple.vue'
import password from '@/components/Password.vue'



export default {
    mixins: [formMixin],
    components: {
        password,
        formContainer,
        // dateInput,
        tab,
        targetSystemTest,
        targetSystemLookup,
        Sftp,
        Ftp,
        Email,
        Docpath,
        tabNav,
        incomingTabContent,
        Kep,
        Uets,
        FileSystem,
        selectMultiple,
        IncomingFilterEditor,
        incomingAlerts
    },
    mounted() {
        this.enableFormValidation()
    },
    created() {
        console.log(this.data);
        this.getDepartments({ predicate: "IsActive= true" })
            .then(x => {
                this.departments = x.Result;
            }).catch(x => {
                console.log("Departman listesi yüklenemedi:", x);
            });
        this.getCategories({predicate: "IsActive=true"})
            .then(x=> {
            this.categories = x.Result;
            })
        this.getAuthorizationDefinitions()
            .then(x => {
                this.auths = x;
            }).catch(x => {
                console.log('Kullanıcı yetki tanımları yüklenemedi.', x);
            })
        this.getUsers({
            predicate: "IsActive= true",
            // DepartmentIds: [this.$route.params.id],
        }).then(x => {
            this.userList = x.Result;
            this.loadingLabel = this.emptyLabel;
        });


        
        if(!this.$route.params.id || this.$route.params.id==this.emptyObjectId){
            this.data = this.incomingChannelTemplate;
        }else {
            this.getData(this.$route.params.id).then(()=>{
                if(this.data.uetsDetails == null){
                    this.data.uetsDetails = this.uetsTemplate;
                }else{
                    this.data.uetsDetails.ApiKey = ""
                }
                this.getUetsInfo()
            });
            
        }
        console.log("data",this.data)
        
    },
    data() {
        return {
            emptyObjectId: window.emptyObjectId,
            loading: false,
            modelName: 'IncomingChannel',

            uetsLoading: false,
            incomingFilter:{
                Id: window.emptyObjectId,
                conditions: [{
                    VariableName: null,
                    VariableMatchType: null,
                    NextConditionConnectionType: null,
                    VariableValue: null,
            }],
                recipients: {
                    UserIds: [],
                    DepartmentIds: []
                },
                filterName: "",
                isActive: true,
                notifyEnabled: false
            },
            filterTemplate:{
                Id: window.emptyObjectId,
                conditions: [{
                    VariableName: null,
                    VariableMatchType: null,
                    NextConditionConnectionType: null,
                    VariableValue: null,
            }],
                recipients: {
                    UserIds: [],
                    DepartmentIds: []
                },
                filterName: "",
                isActive: true,
                notifyEnabled: false
            },
            uetsTemplate: {
                ApiKey: null,
                RequestRate: 0,
            },
            data:{
                Id :window.emptyObjectId,
                name: '',
                type: "Email",
                defaultRecipients: {
                    UserIds: [],
                    DepartmentIds: []
                },
                isActive: true,
                iMapDetails: {},
                remDetails: {},
                uetsDetails: {
                    ApiKey: null,
                    RequestRate: 0,
                    Id: null
                },
                ftpDetails: {},
                archiveDetails: {},
                incomingFilters: []
            },

            incomingChannelTemplate: {
                Id :window.emptyObjectId,
                name: '',
                type: "Email",
                defaultRecipients: {
                    UserIds: [],
                    DepartmentIds: []
                },
                isActive: true,
                iMapDetails: {},
                remDetails: {},
                uetsDetails: {},
                ftpDetails: {},
                archiveDetails: {},
                incomingFilters: []
            },

            departments: [],
            userList: null,
            categories: [],
            tab: 'ortakalan',
            tabs: [
                { key: 'ortakalan', text: this.translate('tabs.incomingChannelTabs.ortakalan') },
                { key: 'filtreleme', text: this.translate('tabs.incomingChannelTabs.filter') },
                { key: 'arsivler', text: this.translate('tabs.incomingChannelTabs.archive') },
            ],
            auths: [],
            lookupResult: null,
            availableTest: ["SFtp", "Ftp", "FileSystem"],
            testResult: null,
            incomingFilterForEdit: false,
            newDocForm: null,
            loadingLabel: this.translate('listFetching'),
            emptyLabel: this.translate('emptyLabel'),
            validationData: [],
            incomingFilterUpdateModal : -1
        }
    },
    methods: {
        typeChanged(value){
            this.uetsLoading = true
            if(value == "Uets" && !window.settings.isOnPrem){
                this.getUetsInfo()
            }else{
                this.uetsLoading = false
            }
        },
        async getUetsInfo() {
            this.uetsLoading = true
            if (!window.settings.isOnPrem) {
                await axios.get('/account/getuetsinfo').then(x => {
                    this.data.uetsDetails.Id = x.data.Id
                    this.data.uetsDetails.RequestRate = x.data.RequestRate
                    this.uetsLoading = false
                }).catch(() => {
                    this.uetsLoading = false
                })
            }
        },
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
        checkIMapDetails(value, event) {
            //for different saved properties: for example this function is for data.imapdetails
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data.iMapDetails, value, editedText)
            } else {
                this.$set(this.data.iMapDetails, value, event.target.value)
            }
        },
        checkRemDetails(value, event) {
            //for different saved properties: for example this function is for data.remdetails
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data.remDetails, value, editedText)
            } else {
                this.$set(this.data.remDetails, value, event.target.value)
            }
        },
        checkSFTPDetails(value, event) {
            //for different saved properties: for example this function is for data.ftpdetails
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data.ftpDetails, value, editedText)
            } else {
                this.$set(this.data.ftpDetails, value, event.target.value)
            }
        },
        handleBlur(e){
            console.log('blur', e.target.value)
            this.validate();
        },
        hasAuth(auth) {
            return this.data?.Authorities?.indexOf(auth) >= 0 || false;
        },
        setAuth(auth, state) {
            this.data.Authorities = this.data.Authorities.filter(x => x != auth);

            if (state)
                this.data.Authorities.push(auth);
        },
        isAuthAvailable(auth) {
            if (auth == 'Admin')
                return false;

            if (auth == 'Approver' || auth == 'Signer')
                return true;

            return !this.hasAuth('Admin');
        },
        goTab(newTab) {
            if (this.tab == 'ortakalan') {
                var input = document.getElementById('MobileSignNumber');
                if (!input.reportValidity())
                    return;
            }

            this.tab = newTab;
        },
        goNextTab() {
            var curIndex = this.tabs.findIndex(x => x.key == this.tab);
            var newTab = this.tabs[curIndex + 1];
            if (newTab)
                this.goTab(newTab.key);
        },
        goPrevTab() {
            var curIndex = this.tabs.findIndex(x => x.key == this.tab) - 1;
            if (curIndex < 0)
                curIndex = 0;

            this.goTab(this.tabs[curIndex].key);
        },
        ftpLookupTargetSystem(customPath) {
            if (!this.validTargetSystem() || this.loading)
                return;

            this.loading = true;

            var formData = Object.assign({}, this.data);

            if (customPath)
                formData.Path = customPath;

            axios
                .post("/TargetSystem/FtpLookup", formData)
                .then((x) => {
                    if (x.data.Success) {
                        this.lookupResult = { TargetSystem: x.data.TargetSystem, Files: x.data.Files };
                    } else {
                        alert(this.translate('incomingDoc.lookupFailed') + x.data.Exception);
                    }
                    this.$forceUpdate();
                })
                .catch((x) => {
                    alert(this.translate('incomingDoc.lookupFailed') + x);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        ftpLookupPathSelected(value) {
            this.data.Path = value;
            this.data.Path = value;
            this.lookupResult = null;
        },
        apply() {
            if(!this.data.incomingFilters)
                this.data.incomingFilters = [];
            if(this.incomingFilterUpdateModal >= 0){
                this.data.incomingFilters[this.incomingFilterUpdateModal] = this.incomingFilter;

            }else{
                this.data.incomingFilters.push(this.incomingFilter);
            }
            // console.log(this.validationData);
            // console.log("hop", this.incomingFilter);
            // console.log("hop2", this.data);
            // console.log("hop3", this.data.incomingFilters)
            // console.log("-----------bunun altında incomingfilter var----")
            // console.log(this.incomingFilters);
            this.incomingFilterForEdit = false;
        },
        deleteFilter(counter) {
            this.data.incomingFilters.splice(counter, 1);
        },
        editFilter(item,counter) {
            this.incomingFilterUpdateModal = counter;
            this.incomingFilterForEdit = true;
            this.incomingFilter = item
            //console.log(item);
            //console.log(this.incomingFilter);
        },
        addFilter(){
            console.log("ff",this.incomingFilter);
            console.log("f2f",this.filterTemplate);
            
            this.incomingFilter = JSON.parse(JSON.stringify(this.filterTemplate));
            this.incomingFilterUpdateModal = -1;
            this.incomingFilterForEdit = true;
            
        },
        saveChannel() {

        if (this.data.type == "Sftp") {
            this.data.ftpDetails.isSecure = true
        } else if (this.data.tpye == "Ftp") {
            this.data.ftpDetails.isSecure = false
        }

        if(this.data.archiveDetails.ReadExpirationDay == null || this.data.archiveDetails.DefaultExpirationDay == null){
            alert(this.translate('errors.readDocFieldMustBeFilled'))
        } else if(this.data.archiveDetails.ReadExpirationDay > 10){
            alert(this.translate('errors.readDocFieldMaxTen'))
        } else if(this.data.archiveDetails.DefaultExpirationDay > 30){
            alert(this.translate('errors.unreadDocFileMaxThirty'))
        }
        else{
            console.log(this.data);

            axios.post(`/incomingChannel/Post/`, this.data)
                .then(x => {
                    console.log(x)
                    // error message 
                    // if (x.data.Success) {
                    this.$router.push({
                        name: "IncomingChannelList",
                    });
                    // } else {
                    // alert(x.data.ErrorMessages);
                    // this.loading = false;
                    // }
                })
                .catch(x => {
                    console.warn('Gönderilemedi: ', x);
                    window.processErrorResponse(x, this);
                })
        }
        },
        validateChannel() {
            this.validate().then((x) => {
                console.log("validate results: ", x);
                if (x, x.status != 200) {
                    this.validationData = x.data;
                }
            })
        },
    }
}
</script>
<style scoped>
.tab-panel {
    min-height: 600px;
}

.text-muted {
    margin: 0 0 12px 17px
}

.editButton {
    background-color: transparent;
    border-radius: 5px;
    transition: 0.4s;
    border: 1px solid transparent;
}

.deleteButton {
    border: 1px solid transparent;
    background-color: transparent;
    padding: 2px 5px;
    border-radius: 5px;
    transition: 0.4s;
}
</style>